export const NS_COMMON = 'common';
export const NS_TERMS_OF_USE = 'termsOfUse';

export const NSC_RT = 'common/rt';
export const NSC_STUDY = 'common/study';
export const NSC_ENCOUNTER = 'common/encounter';
export const NSC_FILE = 'common/file';
export const NSC_STIPEND = 'common/stipend';
export const NSC_REIMBURSEMENT = 'common/reimbursement';
export const NSC_ADDRESS = 'common/address';
export const NSC_CONFIRMATIONS = 'common/confirmations';
export const NSC_PATIENT = 'common/patient';

export const NSL_NAVBAR = 'layout/navbar';
export const NSL_ROUTES = 'layout/routes';

export const NSPG_PREFERENCES = 'pages/generic/preferences';
export const NSPG_USER = 'pages/generic/user';

export const NSPP_STIPEND = 'pages/patient-source/stipend';
export const NSPP_REIMBURSEMENT = 'pages/patient-source/reimbursement';
export const NSPP_PATIENT = 'pages/patient-source/patient';
export const NSPP_LOGS = 'pages/patient-source/logs';
export const NSPP_NOTES = 'pages/patient-source/notes';
export const NSPP_CARD = 'pages/patient-source/card';
export const NSPP_ENABLEMENT = 'pages/patient-source/enablement';
export const NSPP_TRAVEL = 'pages/patient-source/travel';
export const NSPP_INFORMED_CONSENT = 'pages/patient-source/informedConsent';
export const NSPP_WITHDRAW_REASONS = 'pages/patient-source/patientWithdrawReasons';
export const NSPP_VALIDATION = 'pages/patient-source/validation';

export const NSPS_STUDY = 'pages/study/study';
export const NSPS_SITE = 'pages/study/site';

const namespaces = [
  NS_COMMON,
  NS_TERMS_OF_USE,

  NSC_RT,
  NSC_STUDY,
  NSC_ENCOUNTER,
  NSC_FILE,
  NSC_STIPEND,
  NSC_REIMBURSEMENT,
  NSC_ADDRESS,
  NSC_CONFIRMATIONS,
  NSC_PATIENT,

  NSL_NAVBAR,
  NSL_ROUTES,

  NSPG_PREFERENCES,
  NSPG_USER,

  NSPP_STIPEND,
  NSPP_REIMBURSEMENT,
  NSPP_PATIENT,
  NSPP_LOGS,
  NSPP_NOTES,
  NSPP_CARD,
  NSPP_ENABLEMENT,
  NSPP_TRAVEL,
  NSPP_INFORMED_CONSENT,
  NSPP_WITHDRAW_REASONS,
  NSPP_VALIDATION,

  NSPS_STUDY,
  NSPS_SITE
];

export default namespaces;
